"use strict";

exports.resolve = val => {
  if (typeof val === 'function') {
    return val();
  }

  return val;
};